var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 52,
    viewBox: "0 0 13 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 6.08219C10.5 7.55271 9.80016 15.1192 8.62795 22.4036C8.04476 26.0276 7.36428 29.4526 6.63225 31.9341C6.58779 32.0848 6.54369 32.2301 6.5 32.37C6.45631 32.2301 6.41221 32.0848 6.36775 31.9341C5.63572 29.4526 4.95524 26.0276 4.37205 22.4036C3.19984 15.1192 2.5 7.55271 2.5 6.08219C2.5 4.25765 4.13181 2.5 6.5 2.5C8.86819 2.5 10.5 4.25765 10.5 6.08219ZM13 6.08219C13 9.44129 10.0899 37 6.5 37C2.91015 37 0 9.44129 0 6.08219C0 2.72309 2.91015 0 6.5 0C10.0899 0 13 2.72309 13 6.08219ZM10.5 46C10.5 47.933 8.933 49.5 7 49.5C5.067 49.5 3.5 47.933 3.5 46C3.5 44.067 5.067 42.5 7 42.5C8.933 42.5 10.5 44.067 10.5 46ZM13 46C13 49.3137 10.3137 52 7 52C3.68629 52 1 49.3137 1 46C1 42.6863 3.68629 40 7 40C10.3137 40 13 42.6863 13 46Z",
    fill: "#D91F05"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/union.7c819752ec5c08f462117834ff63be58.svg";
export { ForwardRef as ReactComponent };